import React from 'react'
import { injectIntl } from 'react-intl'
import { Button } from '@material-ui/core'
import messages from './translate'

function FeedbackInfo(props) {
  const {
    onAddMoreFbClick,
    email,
    intl: { formatMessage },
  } = props

  return (
    <div className="feedback-info">
      <p>{email}</p>
      <p>{formatMessage(messages.feedbackThanksContent)}</p>
      <Button onClick={onAddMoreFbClick}>
        {formatMessage(messages.addMoreFeedback)}
      </Button>
    </div>
  )
}

export default injectIntl(FeedbackInfo)
